import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import Map from "../components/Contact/MapContent";
import BaseLayout from "../components/global/BaseLayout";
import ContactInfo from "../components/Contact/ContactInfo2";

function Contact() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="Contact">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="Contact"
          Subheader="Contact"
          bgimg={`${rpdata?.gallery?.length > 10 ? rpdata?.gallery?.[5] : rpdata?.stock?.[10]}`}
        />
        <ContactInfo
          image1={rpdata?.gallery?.length > 4 ? rpdata?.gallery?.[4] : rpdata?.stock?.[11]}
          image2={rpdata?.gallery?.length > 9 ? rpdata?.gallery?.[9] : rpdata?.stock?.[12]}
        />
        <Map />
      </div>
    </BaseLayout>
  );
}

export default Contact;
